import '../App.css';
import React, { useState, useEffect } from "react";
// import { Icon } from "leaflet";
import { MapContainer, TileLayer, Marker, Polyline } from 'react-leaflet';
// import { Popup } from 'react-leaflet';
import MapLegend from './maplegend';
import { placesILived, roadtrip1, roadtrip2, roadtrip3, roadtrip4, roadtrip5, miscellaneous, asiaTrip2024 } from '../data/city_markers'
import { blueIcon, redIcon, violetIcon, blackIcon, greenIcon, greyIcon, yellowIcon, orangeIcon, goldIcon } from './custom-icons';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Tooltip } from 'react-leaflet/Tooltip'
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

// h = roads only
// m = standard roadmap
// p = terrain
// r = somehow altered roadmap
// s = satellite only
// t = terrain only
// y = hybrid
// ESRI map tile options: https://sites.google.com/a/blocoware.com/speedohelp/home/map-sources

const trips = [placesILived, roadtrip1, roadtrip2, roadtrip3, roadtrip4, roadtrip5, miscellaneous, asiaTrip2024]

const icons = [blueIcon, redIcon, violetIcon, blackIcon, greenIcon, greyIcon, yellowIcon, orangeIcon, goldIcon]

export default function LeafletMap(props) {
    const [ googleMapType, setGoogleMapType ] = useState('p')
    const [ legendData, setLegendData ] = useState([
        {id: 'placesilived', text: 'Places I\'ve Lived', color: "#2C83CB", checked: true},
        {id: 'roadtrip1', text: 'Roadtrip August 2020', color: "#A03232", checked: true},
        {id: 'roadtrip2', text: 'Roadtrip May 2021', color: "#9D49CB", checked: true},
        {id: 'roadtrip3', text: 'Roadtrip August 2021', color: "#3D3D3C", checked: true},
        {id: 'roadtrip4', text: 'Roadtrip May 2022', color: "#46AD30", checked: true},
        {id: 'roadtrip5', text: 'Roadtrip January 2023', color: "#7B7B7B", checked: true},
        {id: 'miscellaneoustrips', text: 'Miscellaneous Trips', color: "#CBC535", checked: true},
        {id: 'asiaTrip', text: 'Asia Trip 2024', color: "#CF8B43", checked: true},
    ])
    const [ lineData, setLineData ] = useState([])
    const [ showRoadtripLines, setShowRoadtripLines ] = useState(false)

    const styles = {
        legendBox: {
            paddingTop: 20, 
            paddingRight: 20, 
            position: 'absolute', 
            bottom: 25, 
            left: 25, 
            zIndex: 10000, 
            borderRadius: 8, 
            backgroundColor:'rgba(255,255,255,0.5)', 
            boxShadow:'0px 5px 10px 0px rgba(0, 0, 0, 0.5)'
        },
        mapTypeToggle: {
            paddingTop: 20, 
            paddingRight: 20, 
            // position: 'absolute', 
            borderRadius: 3, 
            // backgroundColor:'rgba(255,255,255, 1)', 
            // boxShadow:'0px 5px 10px 0px rgba(0, 0, 0, 0.5)'
        }
    }
    
    // create lines for roadtrip routes
    // add new york and Tucson to front and back of each roadtrip (that's where i started and ended each trip)
    // [32.1, -111.15]
    // [40.8128, -72.5]
    useEffect(() => {
        let tempLineDatas = []
        for (let i = 1; i <= 5; i++) {
            let tempLineData
            if (i % 2 === 1) {
                tempLineData = {"color": legendData[i].color, data: [[40.8128, -72.5]]}
            } else {
                tempLineData = {"color": legendData[i].color, data: [[32.1, -111.15]]}
            }
            
            for (let tripData of trips[i].data) {
                let coordinates = tripData.coordinates
                tempLineData.data.push([coordinates[1], coordinates[0]])
            }
            
            if (i % 2 === 1) {
                tempLineData.data.push([32.1, -111.15])
            } else {
                tempLineData.data.push([40.8128, -72.5])
            }

            tempLineDatas.push(tempLineData)
        }
        setLineData(tempLineDatas)
    }, [legendData])

    const handleCheckLegendItem = (index) => {
        legendData[index].checked = !legendData[index].checked
        setLegendData([...legendData])
    }

    const handleToggleRoadtripLines = (event) => {
        setShowRoadtripLines(!showRoadtripLines)
    }

    return (
        <Box sx={{ px: 4, pb: 5, pt: 3 }}>
            <Grid container>
                <Grid item xs={6}>
                <Box sx={{ p:1 }}>
                    <MapTypeToggle updateMapType={setGoogleMapType} style={styles.mapTypeToggle}/>
                </Box>
                </Grid>
                <Grid item xs={4}></Grid>
                <Grid item xs={2}>
                    <Box sx={{ pt:4 }} >
                    <FormGroup>
                        <FormControlLabel control={<Switch />} label="roadtrip lines" value={showRoadtripLines} onChange={handleToggleRoadtripLines}/>
                    </FormGroup>
                    </Box>
                    
                </Grid>
            </Grid>
            
            
            <Box style={{position: 'relative'}}>
            <MapContainer center={[38, -98]} zoom={5} scrollWheelZoom={true}>

            {/* 
                Google maps 
                for traffic: @221097413,traffic
                add after maptype (lyrs)
            */}
            <TileLayer
                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url={`https://{s}.google.com/vt/lyrs=${googleMapType}&hl=en&x={x}&y={y}&z={z}`}
                subdomains={['mt1','mt2','mt3']}
            />

            {/* Light */}
            {/* <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            /> */}

            {/* Dark */}
            {/* <TileLayer
                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png"
            /> */}

            {/* Nasa Satellite View (similar to above?) */}
            {/* <TileLayer
                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url='https://gibs-{s}.earthdata.nasa.gov/wmts/epsg3857/best/BlueMarble_ShadedRelief_Bathymetry/default//EPSG3857_500m/{z}/{y}/{x}.jpeg'
            /> */}


            {/* <TileLayer
                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url='http://server.arcgisonline.com/ArcGIS/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}.png'
            /> */}


            {trips.map((category, index) => {
                if (legendData[index].checked) {
                return (
                category.data.map((value, i) => {
                    return (
                        <Marker
                            key={value.name}
                            position={[
                                value.coordinates[1],
                                value.coordinates[0]
                            ]}
                            eventHandlers={{
                                click: (e) => {
                                    props.show_photos(value.name)
                                },
                                }}                            
                            icon={icons[index]}
                        >
                            <Tooltip>{value.name}</Tooltip>
                        </Marker>
                    )
                    })
                )
            } else return null
            })}

            {showRoadtripLines && 
            lineData.map((value, index) => {
                return (
                    <Polyline pathOptions={{ color: value.color }} positions={value.data} />
                )
            })}
            </MapContainer>
            <Box style={styles.legendBox}>
                <MapLegend data={legendData} handleChange={handleCheckLegendItem}/>
            </Box>
            </Box>
            
        </Box>
      );
}

function MapTypeToggle(props) {
    const { updateMapType, style } = props
    const [value, setValue] = useState(0);
    const mapTypes = ['p', 's', 'y', 'h']
    const handleChange = (event, newValue) => {
        setValue(newValue);
        updateMapType(mapTypes[newValue])
    };

    return (
        <Box sx={{  }} style={style}>
        <Tabs
            onChange={handleChange}
            value={value}
            aria-label="Tabs where each tab needs to be selected manually"
        >
            <Tab label="Standard" />
            <Tab label="Satellite" />
            <Tab label="Hybrid" />
            <Tab label="Roads" />
        </Tabs>
        </Box>
    );
}